import React, { useEffect } from "react";

export default function Timer({ setSend, send, time, setTime }) {
  useEffect(() => {
    setTime(60);
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(timer);
          setSend((prev) => {
            return { ...prev, send: true };
          });
          return 60;
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [send.run]);
  return <>{time}</>;
}
